<template>
    <div :data-ref="`memo-form-${memo.id}`">
        <v-col cols="12">
            <h3 class="m-0">
                {{ memo.id === 'new' ? t('patients::memo.title.create_memo') : t('patients::memo.title.update_memo') }}
            </h3>
        </v-col>
        <v-col cols="12" xl="10">
            <v-row class="pb-6">
                <v-col cols="12" lg="4" class="pb-0">
                    <b-select
                        to-mutate="memo::memo.memo_type"
                        :label="t('patients::memo.form.label.memo_type')"
                        :select-items="memo_types"
                        :rules="validationRules.memo_type"
                        :readonly="readOnlyRules"
                        mandatory
                    ></b-select>
                </v-col>
                <v-col cols="12" lg="4" class="pb-0">
                    <b-input
                        to-mutate="memo::memo.action"
                        :label="t('patients::memo.form.label.action')"
                        :rules="validationRules.action"
                        :readonly="readOnlyRules"
                        mandatory
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="4" class="pb-0">
                    <b-date-picker-store
                        to-mutate="memo::memo.memo_date"
                        :label="t('patients::memo.form.label.memo_date')"
                        :rules="validationRules.memo_date"
                        :readonly="readOnlyRules"
                        :hint="t('patients::memo.form.hint.memo_date')"
                        persistent-hint
                    ></b-date-picker-store>
                </v-col>
                <v-col>
                    <b-textarea
                        to-mutate="memo::memo.memo_text"
                        :label="t('patients::memo.form.label.memo_text')"
                        :rules="validationRules.memo_text"
                        :readonly="readOnlyRules"
                        mandatory
                        rows="3"
                    ></b-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="justify-content-start d-flex py-4">
                    <v-btn rounded text color="primary" @click="goBack()">
                        {{ t('patients::button.cancel') }}
                    </v-btn>

                    <v-btn
                        v-if="can('api.v1.patients.memos.update') || can('api.v1.patients.memos.store')"
                        :loading="memoLoading"
                        :disabled="readOnlyRules"
                        color="primary"
                        rounded
                        class="ml-4"
                        @click="saveMemo()"
                    >
                        {{ t('patients::memo.button.save') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </div>
</template>

<script>
export default {
    data() {
        return {
            memoForm: false,
            memoLoading: false,
            validationRules: {
                memo_text: [(v) => !!v || t('default::validation.field.required')],
                action: [(v) => !!v || t('default::validation.field.required')],
                memo_type: [(v) => !!v || t('default::validation.field.required')],
            },
            memo_types: [],
        };
    },
    computed: {
        readOnlyRules() {
            return (
                (!this.can('api.v1.patients.memos.update') || !this.can('api.v1.patients.memos.store')) &&
                this.can('api.v1.patients.memos.show')
            );
        },

        patient() {
            return this.$store.state.patients.patient;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        memo() {
            return this.$store.state.memo.memo;
        },
    },
    created() {
        axios.get(route('api.v1.memos.config')).then((response) => {
            this.memo_types = response.data.memo_types;
        });
    },
    mounted() {},

    methods: {
        async saveMemo() {
            this.memoLoading = true;
            this.$store.dispatch('memo/resetErrorMessages');
            return await axios({
                method: this.memo.id !== 'new' ? 'put' : 'post',
                url:
                    this.memo.id !== 'new'
                        ? route('api.v1.patients.memos.update', { patient: this.patientId, memo: this.memo.id })
                        : route('api.v1.patients.memos.store', { patient: this.patientId }),
                data: this.memo,
            })
                .then(() => {
                    this.$root.notify(
                        'info',
                        t('patients::memo.form.success.title'),
                        this.memo.id !== 'new'
                            ? t('patients::memo.form.success.updated.message')
                            : t('patients::memo.form.success.create.message')
                    );
                    this.$store.dispatch('patients/reloadPatientData');
                    this.goBack();
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('memo/setErrorMessages', error.response.data.errors);
                        this.scrollToError();
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.memoLoading = false), 400));
        },
        scrollToError() {
            const element = this.$el.querySelector('.v-messages__message');
            if (!element) {
                return;
            }
            const offset = 50;
            const headerOffset = document.querySelector('.v-app-bar').offsetHeight + offset;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        },
        goBack() {
            this.$store.dispatch('memo/resetForm');
            this.$store.dispatch('memo/resetErrorMessages');
            this.$store.dispatch('patients/changeTab', 5);
        },
    },
};
</script>
<style scoped></style>
